import { cn } from "@/core/helpers/cn";

type Props = {
  size?: number;
  svgSize?: number;
  className?: string;
  classNameSvg?: string;
  fill?: string;
};

export default function Corner({
  size = 8,
  svgSize = 8,
  className,
  classNameSvg,
  fill = "currentColor",
}: Props) {
  return (
    <div
      className={cn("absolute top-0 right-0 pointer-events-none z-2", className)}
      style={{ width: `${size}px`, height: `${size}px` }}
    >
      <svg
        viewBox="0 0 8 8"
        width={svgSize}
        height={svgSize}
        className={cn("w-full h-full", classNameSvg)}
      >
        <defs>
          <mask id="notch-tr" maskUnits="userSpaceOnUse">
            <rect x="0" y="0" width="8" height="8" fill="#fff" />
            <circle cx="0" cy="8" r="8" fill="#000" />
          </mask>
        </defs>

        <rect x="0" y="0" width="8" height="8" fill={fill} mask="url(#notch-tr)" />
      </svg>
    </div>
  );
}
